import axios from 'axios';

class Analytics {
    constructor() {
        this.id                = null;
        this.trackingId        = null;
        this.clientId          = null;
        this.userId            = null;
        this.hostname          = null;
        this.endpoint          = null;
        this.path              = null;
        this.href              = null;
        this.ga4MeasurementId  = null;
        this.ga4Session        = null;
        this.ga4Secret         = null;
        this.isLoggingEnabled  = false;
        this.profile           = null;
        this.isPreventTracking = false;
        this.facebookId        = null;
        this.facebookSecret    = null;
    }

    setId(id) {
        this.id = id;
    }

    setIsLoggingEnabled(isLoggingEnabled) {
        this.isLoggingEnabled = isLoggingEnabled;
    }

    setEndpoint(endpoint) {
        if (! endpoint) {
            this.isPreventTracking = true;
        }
        else {
            this.endpoint = `https://${endpoint}.execute-api.us-east-1.amazonaws.com/track`;
        }
    }

    setHostname(hostname) {
        this.hostname = hostname;
    }

    setPath(path) {
        this.path = path;
    }

    setHref(href) {
        this.href = href;
    }

    setTrackingId(tid) {
        this.trackingId = tid && tid.trim().length > 0
            ? tid
            : false;
    }

    setUserId(uid) {
        this.userId = uid;
    }

    setClientId(cid) {
        this.clientId = cid;
    }

    setProfile(profile) {
        this.profile = profile;
    }

    setGa4MeasurementId(id) {
        this.ga4MeasurementId = id;
    }

    setGa4Session(session) {
        this.ga4Session = session;
    }

    setGa4Secret(secret) {
        this.ga4Secret = secret;
    }

    setFacebookId(facebookId) {
        this.facebookId = facebookId;
    }

    setFacebookSecret(facebookSecret) {
        this.facebookSecret = facebookSecret;
    }

    getClientId() {
        return this.clientId && this.clientId.split('.').length === 4
            ? this.clientId.split('.')[2] + '.' + this.clientId.split('.')[3]
            : false;
    }

    getHref() {
        return this.href;
    }

    trackEvent(action, label) {
        this.log('track event: ' + action + '|' + label + ' for GA ID ' + this.trackingId + ', Widget ID: ' + this.id);

        if (!this.isPreventTracking) {
            axios.post(this.endpoint, {
                widget: this.id,
                action: action,
                label: label,
                host: this.hostname,
                path: this.path,
                href: this.href,
                tid: this.trackingId,
                cid: this.getClientId(),
                uid: this.userId,
                ga4_mid: this.ga4MeasurementId,
                ga4_sid: this.ga4Session,
                ga4_s: this.ga4Secret,
                profile: this.profile,
                fb_id: this.facebookId,
                fb_s: this.facebookSecret,
            })
            .catch(function (error) {
                console.error(error);
            });
        }
    }

    log(msg) {
        if (this.isLoggingEnabled) {
            console.log(msg)
        }
    }
}

export default Analytics;
